module.exports = __webpack_public_path__ + "img/pic2.151f04d1.jpg";